import { getScoreTags } from './scoreTags';
import { DEFAULT_SCORE_ARTIST } from './scoreDefaults';

export const normalizeScoresResponse = (data) => {
  if (Array.isArray(data?.scores)) return data.scores;
  if (Array.isArray(data)) return data;
  return [];
};

export const getScoreUpdatedDate = (score) =>
  new Date(score?.updatedAt || score?.score?.updatedAt || score?.createdAt || 0);

export const sortScoresByUpdatedAt = (scores = []) =>
  [...scores].sort((a, b) => getScoreUpdatedDate(b) - getScoreUpdatedDate(a));

export const filterScores = (scores = [], query = '') => {
  if (!query.trim()) return scores;
  const normalizedQuery = query.trim().toLowerCase();
  return scores.filter((score) => {
    const title = (score?.title || '').toLowerCase();
    const artist = (score?.artist || '').toLowerCase();
    const tags = getScoreTags(score);
    if (/^[#＃]/.test(normalizedQuery)) {
      const tagQuery = normalizedQuery.replace(/^[#＃]+/, '');
      return tags.some((tag) => tag.toLowerCase().includes(tagQuery));
    }
    return title.includes(normalizedQuery) || artist.includes(normalizedQuery)
      || tags.some((tag) => tag.toLowerCase().includes(normalizedQuery));
  });
};

export const sortScores = (scores = [], sortKey = 'updated-desc') => {
  const copy = [...scores];
  switch (sortKey) {
    case 'updated-asc':
      return copy.sort(
        (a, b) => getScoreUpdatedDate(a) - getScoreUpdatedDate(b)
      );
    case 'title-asc':
      return copy.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
    case 'artist-asc':
      return copy.sort((a, b) =>
        (a.artist || DEFAULT_SCORE_ARTIST).localeCompare(
          b.artist || DEFAULT_SCORE_ARTIST
        )
      );
    case 'updated-desc':
    default:
      return copy.sort(
        (a, b) => getScoreUpdatedDate(b) - getScoreUpdatedDate(a)
      );
  }
};

export const groupScoresByArtist = (scores = []) => {
  const grouped = new Map();
  scores.forEach((score) => {
    const artistName =
      score?.artist && score.artist.trim()
        ? score.artist.trim()
        : DEFAULT_SCORE_ARTIST;
    if (!grouped.has(artistName)) {
      grouped.set(artistName, []);
    }
    grouped.get(artistName).push(score);
  });

  return Array.from(grouped.entries());
};
